/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Alert, Space, Modal } from "antd";
import { connect } from "react-redux";
import {
	InfoCircleOutlined,
	WarningOutlined,
	ExclamationCircleOutlined,
} from "@ant-design/icons";
import { signOut } from "redux/actions/Auth";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const NavAlertas = ({ isMobile, avisos = [] }) => {
	const history = useHistory();
	const [modalVisible, setModalVisible] = useState(false);

	const getNotificationIcon = (tipo) => {
		if (tipo === "warning") {
			return <WarningOutlined style={{ color: "#faad14" }} />;
		} else if (tipo === "danger") {
			return <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />;
		}
		return <InfoCircleOutlined style={{ color: "#1890ff" }} />;
	};

	const handleAvisoClick = (aviso) => {
		if (isMobile) {
			setModalVisible(true);
		} else if (aviso.link) {
			history.push(aviso.link);
		}
	};

	const handleModalOk = () => {
		setModalVisible(false);
		// Se tem link, navega após fechar o modal
		if (avisos.length > 0 && avisos[0].link) {
			history.push(avisos[0].link);
		}
	};

	// Renderiza os alertas inline na barra de navegação
	const renderInlineAlerts = () => {
		if (!avisos || avisos.length === 0) return null;

		const primeiroAviso = avisos[0];

		if (isMobile) {
			// No mobile, mostra apenas o ícone
			return (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						marginRight: "16px",
					}}
				>
					<div
						onClick={() => handleAvisoClick(primeiroAviso)}
						style={{
							cursor: "pointer",
							fontSize: "18px",
							animation: "mobileIconPulse 2s infinite",
							...(primeiroAviso.tipo === "danger" && {
								animation:
									"mobileIconPulseDanger 1.5s infinite",
							}),
						}}
					>
						{getNotificationIcon(primeiroAviso.tipo)}
						<style>
							{`
								@keyframes mobileIconPulse {
									0% { 
										transform: scale(1);
										box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.7);
										border-radius: 50%;
									}
									50% { 
										transform: scale(1.1);
										box-shadow: 0 0 15px 10px rgba(24, 144, 255, 0.3);
										border-radius: 50%;
									}
									100% { 
										transform: scale(1);
										box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);
										border-radius: 50%;
									}
								}
								
								@keyframes mobileIconPulseDanger {
									0% { 
										transform: scale(1);
										box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.7);
										border-radius: 50%;
									}
									50% { 
										transform: scale(1);
										box-shadow: 0 0 12px 8px rgba(255, 77, 79, 0.3);
										border-radius: 50%;
									}
									100% { 
										transform: scale(1);
										box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
										border-radius: 50%;
									}
								}
							`}
						</style>
					</div>
				</div>
			);
		}

		// No desktop, mostra o alerta completo
		return (
			<div
				style={{
					flex: 1,
					overflow: "hidden",
					marginRight: "16px",
					display: "flex",
					alignItems: "center",
				}}
			>
				<Space
					direction="horizontal"
					style={{ width: "100%", overflow: "auto" }}
				>
					{avisos.slice(0, 1).map((aviso, index) => (
						<div
							key={index}
							onClick={() => handleAvisoClick(aviso)}
							style={{
								cursor: aviso.link ? "pointer" : "default",
							}}
						>
							<Alert
								message={aviso.mensagem}
								type={
									aviso.tipo === "danger"
										? "error"
										: aviso.tipo
								}
								showIcon
								icon={getNotificationIcon(aviso.tipo)}
								style={{
									margin: 10,
									whiteSpace: "nowrap",
									...(aviso.link && {
										textDecoration: "underline",
									}),
									...(aviso.tipo === "danger" && {
										fontWeight: "bold",
										animation: "pulse 2s infinite",
									}),
								}}
							/>
						</div>
					))}
				</Space>
			</div>
		);
	};

	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				width: "100%",
			}}
		>
			{renderInlineAlerts()}

			{/* Modal para mobile */}
			{isMobile && (
				<Modal
					title="Aviso"
					visible={modalVisible}
					onOk={handleModalOk}
					onCancel={() => setModalVisible(false)}
					okText={
						avisos.length > 0 && avisos[0].link
							? "Ir para página"
							: "OK"
					}
					cancelText="Fechar"
				>
					{avisos.length > 0 && (
						<Alert
							message={avisos[0].mensagem}
							type={
								avisos[0].tipo === "danger"
									? "error"
									: avisos[0].tipo
							}
							showIcon
							icon={getNotificationIcon(avisos[0].tipo)}
							style={{
								...(avisos[0].tipo === "danger" && {
									fontWeight: "bold",
								}),
							}}
						/>
					)}
				</Modal>
			)}
		</div>
	);
};

const mapStateToProps = ({ user, menu }) => {
	return {
		user: { ...user },
		avisos: menu.avisos,
	};
};

export default connect(mapStateToProps, { signOut })(NavAlertas);
